'use client';

import { Box, Flex } from '@coolblue-development/freddy';
import StickyProductSummaryBar from '@features/comparison/components/StickyProductSummaryBar';
import type { ReactNode } from 'react';
import { useRef } from 'react';

import { useScrollSync } from '../hooks/useScrollSync';
import type { Product } from '../typings/types';
import Buttons from './Carousel/Buttons';
import CarouselTriggers from './Carousel/Triggers';
import { ComparisonContextProvider } from './ComparisonContext';

type ScrollSyncProps = {
  products: Product[];
  children: ReactNode;
};

function ScrollSync({ products, children }: ScrollSyncProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const stickyBarRef = useRef<HTMLDivElement>(null);

  const { scrollTo } = useScrollSync({
    refs: [containerRef, stickyBarRef],
    direction: 'horizontal'
  });

  return (
    <ComparisonContextProvider>
      <Buttons containerRef={stickyBarRef} scrollTo={scrollTo} />
      <Flex
        sx={{
          overflow: 'auto',
          position: 'relative'
        }}
        ref={containerRef}
      >
        <Box pr={{ xs: 400, sm: '2.6rem', md: 0 }} sx={{ flex: '0 0 auto', position: 'relative' }}>
          <CarouselTriggers />
          <StickyProductSummaryBar
            products={products}
            scrollRef={stickyBarRef}
            buttons={<Buttons containerRef={stickyBarRef} scrollTo={scrollTo} smaller={true} />}
          />
          {children}
        </Box>
      </Flex>
    </ComparisonContextProvider>
  );
}

export default ScrollSync;
